import { useState } from "react";
import axios from "axios";

function Register(){

  const [name,setName] = useState("");
  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");

  const handleSubmit = async(e)=>{
    e.preventDefault();

    await axios.post("https://pet-adoption-system-8duc.onrender.com/api/auth/register",{
      name,
      email,
      password
    });

    alert("User Registered");
  };

  return(

    <div>

      <h2>Register</h2>

      <form onSubmit={handleSubmit}>

        <input placeholder="Name"
        onChange={(e)=>setName(e.target.value)} />

        <input placeholder="Email"
        onChange={(e)=>setEmail(e.target.value)} />

        <input type="password"
        placeholder="Password"
        onChange={(e)=>setPassword(e.target.value)} />

        <button type="submit">Register</button>

      </form>

    </div>

  );
}

export default Register;